export function formatDate(date) {
  // Define month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Get parts of the date
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes();

  // Format hours and minutes
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  // Return formatted date string
  return `${month} ${day}, ${year} at ${hours}:${formattedMinutes} ${period}`;
}

export const formatDateWithTime = (dateString) => {
  const date = new Date(dateString);

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  return (
    date.toLocaleDateString("en-US", options).replace(",", "") +
    " at " +
    date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
  );
};

export default formatDate;

export const formatDateTime = (dateTimeString) => {
  const date = new Date(dateTimeString);

  // Extract date components
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  // Extract time components
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  // Return formatted date and time
  return `${year}-${month}-${day} at ${hours}:${minutes}`;
};

// Example usage:
const dateTimeString = "2024-09-16T14:28:44.095411";
console.log(formatDateTime(dateTimeString));
